<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
html,body {
    padding: 0;
    margin: 0;
}
.el-card__body {
  padding: 20px 20px 40px!important;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: auto!important;
}
</style>
